{
  "actions": "פעולות",
  "hideButtonLabel": "הצג פחות",
  "noTags": "ללא",
  "showAllButtonLabel": "הצג הכל ({tagCount, number})"
}
